<template>
  <nav>
    <NavigationBar />
    <router-view />
    <FooterBar />
    <ScrollToTop />
  </nav>
</template>

<script setup>
import NavigationBar from "./components/NavigationBar.vue";
import FooterBar from "./components/FooterBar.vue";
import ScrollToTop from "./components/ScrollToTop.vue";
</script>

<style>
/* 初始化所有样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Helvetica, "PingFang SC", "Microsoft Yahei", sans-serif;
}

img {
  width: 100%;
}

:root {
  /* 主色调系统 */
  --primary-color: #108ee9;
  --primary-hover: #0e7bc7;
  --secondary-color: #e3e3e3;

  /* 文字颜色 */
  --text-color-lightest: #e7e9ec;
  --text-color-darker: #2e2e2e;
  --text-color-dark: #494949;
  --text-color-gray: #8b8b8b;
  --text-color-dark-gray: #727272;
  --text-color-light-gray: #c6c6c6;

  /* 背景与遮罩 */
  --backdrop-color: rgba(42, 42, 42, 0.69);
  --dropdown-bg: #ffffff;
  --dropdown-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  --mobile-menu-bg: #ffffff;
  --mobile-dropdown-bg: #f8f9fa;

  /* 边框与效果 */
  --border-color: #eeeeee;
  --transition-speed: 0.3s;
}
</style>